import { render, staticRenderFns } from "./PersonServicesTable.vue?vue&type=template&id=5b3ccff3&scoped=true"
import script from "./PersonServicesTable.vue?vue&type=script&lang=js"
export * from "./PersonServicesTable.vue?vue&type=script&lang=js"
import style0 from "./PersonServicesTable.vue?vue&type=style&index=0&id=5b3ccff3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3ccff3",
  null
  
)

export default component.exports